import { FunctionComponent } from 'react';

const QnaAgreementInfoBox: FunctionComponent = () => {
  return (
    <div className='flex w-full flex-col gap-[12px] bg-gray-30 p-[24px]'>
      <div className='typography-ui-15sb w-full text-gray-700'>실시간 의료 상담은 이렇게 운영돼요.</div>

      <ul className='flex w-full list-disc flex-col gap-[8px] pl-[16px] marker:text-gray-400'>
        <li className='typography-ui-13r pl-[4px] text-gray-500'>
          폭력적·공격적인 내용, 서비스 목적과 맞지 않는 질문, 동일 내용의 반복(3회 이상) 등은 사전 예고 없이 삭제될 수
          있습니다.
        </li>

        <li className='typography-ui-13r pl-[4px] text-gray-500'>
          서비스 운영을 방해하는 행위가 반복될 경우, 회원과 의료진 보호를 위해 서비스 이용이 사전 안내 없이 한시적 또는
          영구적으로 제한될 수 있습니다.
        </li>

        <li className='typography-ui-13r pl-[4px] text-gray-500'>
          실시간 의료 상담에서 등록된 질문과 답변은 모두에게 공개되며, 서비스 홍보 목적으로 활용될 수 있습니다.
        </li>

        <li className='typography-ui-13r pl-[4px] text-gray-500'>
          답변은 <span className='typography-ui-13sb'>참고용</span>으로서 의학적 판단이나 진료 행위를{' '}
          <span className='typography-ui-13sb'>대체할 수 없으며,</span> 모든 약물 상호작용을 포함하지 않을 수 있습니다.
          이에 대해 닥터나우와 답변 의료인은 어떠한 책임도 지지 않습니다.
        </li>

        <li className='typography-ui-13r pl-[4px] text-gray-500'>
          정확한 진단을 위해서는 닥터나우 앱에서 비대면 진료를 신청하거나, 가까운 병원에 내원해 주세요.
        </li>

        <li className='typography-ui-13r pl-[4px] text-gray-500'>
          실시간 의료 상담에 등록한 질문은 고객센터를 통한 삭제 요청이 없는 한 계속 남게 됩니다.
        </li>
      </ul>
    </div>
  );
};

export default QnaAgreementInfoBox;
